<template>
    <div class="body">

            <el-button class="addTours" type="primary"  @click="line = true">+添加线路</el-button>
            <template>
                <el-table :data="tableData" border  :header-cell-style="tableHeaderColor" style="width: 100%">
                <el-table-column  prop="id"  label="序号" width="80"></el-table-column>
                <el-table-column prop="dayId" label="单天id" width="80"></el-table-column>
                <el-table-column prop="introduce" label="介绍"></el-table-column>
                <el-table-column prop="traffic" label="交通" ></el-table-column>
                <el-table-column prop="highlight" label="高亮文字" ></el-table-column>
                <el-table-column prop="prompt" label="提示" ></el-table-column>
                <el-table-column prop="address" label="操作" width="200" >
                  <template slot-scope="scope">
                      <el-button type="primary" @click.native.prevent="deleteTours(scope.row)">删除</el-button>
                      <el-button type="primary" @click.native.prevent="updateTours(scope.row)">修改</el-button>
                  </template>
                </el-table-column>
                </el-table>
            </template>

             <el-dialog title="添加线路"  :visible.sync="line"   width="30%"   :before-close="handleClose">
                <el-form ref="form" :model="form" class="form" label-width="80px">

                    <el-form-item label="介绍:">
                        <el-input v-model="form.introduce"  placeholder="请输入内容"></el-input>
                    </el-form-item>

                    <el-form-item label="交通:">
                        <el-input v-model="form.traffic" placeholder="请输入内容"></el-input>
                    </el-form-item>

                    <el-form-item label="提示:">
                        <el-input v-model="form.prompt" placeholder="请输入内容"></el-input>
                    </el-form-item>

                    <el-form-item label="高亮文字:">
                        <el-input v-model="form.highlight" placeholder="请输入内容"></el-input>
                    </el-form-item>

                    <el-form-item class="imgForm" label="图片:">
                      <el-upload class="avatar-uploader img" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                          <img v-if="form.coverFile" :src="form.coverFile" class="avatar">
                          <i v-else class="el-icon-plus avatar-uploader-icon "></i>
                      </el-upload>
                    </el-form-item>

                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="line = false">取 消</el-button>
                    <el-button type="primary" @click="onSubmit">确 定</el-button>
                </span>
            </el-dialog>

           
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('toursVip')
  export default {
    data() {
      return {
        tableData: [],
        num: 3,
        imgUrl: '',
        line:false,
        form:{
          id:null,
          dayId:173,
          introduce:'',
          imgUrl: '',
          traffic: '',
          prompt:'',
          highlight:'',
          coverFile:'',
        },
        file:null,
        current:1,
        total:50
      }
    },
    mounted(){
        this.form.dayId = this.id
        this.home(this.id);
    },
    computed:{
      ...mapState({
         id:state=>state.dayId
      })
    },
    methods: {
        //主页
        home(id){
            let that = this
            this.joker.tours.everCourseList(id).then(res=>{
                  console.log(res)
                  that.tableData = res.content
            }).catch(res=>{
                  console.log(res)
            })
        },
      //添加行程
      onSubmit() {
        console.log(this.form)
        let that = this
        that.line = false
        console.log(that.form)
        console.log()

        let  formData = new FormData();
        formData.append('id',this.form.id)
        formData.append('dayId',this.form.dayId)
        formData.append('introduce',this.form.introduce)
        formData.append('traffic',this.form.traffic)
        formData.append('prompt',this.form.prompt)
        formData.append('highlight',this.form.highlight)
        if(this.file!=null){formData.append('coverFile',this.file)}

        if(this.form.id == null){
            this.joker.tours.addEverCourse(formData).then(res=>{
            console.log(res)
              if(res.success){
                this.$message('添加成功');
                  this.home(this.id);
              }
            }).catch(res=>{
                console.log(res)
            })
        }else{
            this.joker.tours.updateEverCourse(formData).then(res=>{
            console.log(res)
              if(res.success){
                this.$message('修改成功');
                  this.home(this.id);
              }
            }).catch(res=>{
                console.log(res)
           })
        }

        
      },

      //编辑行程
      updateTours(row){
        this.form = row
        this.form.coverFile = row.imgUrl
        this.line = true
      },

      //删除行程
      deleteTours(row){
          this.joker.tours.deleteEverCourse(row.id).then(res=>{
            console.log(res)
              if(res.success){
                 this.$message('删除成功');
                  this.home(this.id);
              }
            }).catch(res=>{
                console.log(res)
           })
      },

      handleAvatarSuccess(res, file) {
        this.form.coverFile = URL.createObjectURL(file.raw);
        this.file = file.raw
      },

      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }){
          if (rowIndex === 0) {
              return 'background-color: #409EFF;color: #fff'
          }
      },

       //添加弹框
      handleClose(done) {
        this.$confirm('确认关闭？')
        .then(_ => {
          done();
          var form ={id:null,productName: '',teamType: '',departCityName: '',characteristic: '',duration:'',price:'',coverFile: ''}
          this.form = form
        })
        .catch(_ => {});
      },

      handleChange(value) {
        console.log(value);
      }


    }
  }
</script>


<style scoped>

  .form{
    padding-top: 1%;
    padding-bottom: 1%;
  }

  .img{
      margin-right: 90%;
  }

 .day{
     margin-right: 90%;
 }
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px dashed #409EFF;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .addTours{
    margin-right: 90%;
    margin-top: 1%;
    margin-bottom: 1%;
  }

</style>


// WEBPACK FOOTER //
// src/components/Vip/Tours/EverCourse.vue